/**
 * API client for admin dashboard.
 */

export interface ApiResponse<T> {
  data?: T
  error?: { message: string; code: string }
}

let activeBrandId: string | null = null

export function setActiveBrand(brandId: string | null) {
  activeBrandId = brandId
}

export function getActiveBrand(): string | null {
  return activeBrandId
}

export async function apiFetch<T>(
  url: string,
  options?: RequestInit,
): Promise<ApiResponse<T>> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(options?.headers as Record<string, string> ?? {}),
  }

  const response = await fetch(url, {
    ...options,
    credentials: 'include',
    headers,
  })

  if (!response.ok && response.status >= 500) {
    return { error: { message: 'Server error. Please try again.', code: 'SERVER_ERROR' } }
  }

  return response.json() as Promise<ApiResponse<T>>
}

export function buildQuery(params: Record<string, string | number | undefined | null>): string {
  const filtered = Object.entries(params).filter(
    ([_, v]) => v !== undefined && v !== null && v !== '',
  )
  if (filtered.length === 0) return ''
  return '?' + filtered.map(([k, v]) => `${k}=${encodeURIComponent(String(v))}`).join('&')
}
